<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-row justify="center">
          <picture>
            <source
              media="(max-width: 700px)"
              sizes="75vw"
              srcset="../assets/logo-bredtmann-md.png 356w, ../assets/logo-bredtmann-lg.png 506w, ../assets/logo-bredtmann-xl.png 712w"
            >
            <source
              media="(max-width: 1400px)"
              sizes="40vw"
              srcset="../assets/logo-bredtmann-md.png 356w, ../assets/logo-bredtmann-lg.png 506w, ../assets/logo-bredtmann-xl.png 712w"
            >
            <img
              src="../assets/logo-bredtmann-lg.png"
              alt="Logo Bredtmann - wundervolle Haare"
              class="my-3"
            >
          </picture>
          <!-- <img
            src="../assets/logo-bredtmann-sm.png"
            sizes="80vw"
            srcset="../assets/logo-bredtmann-md.png 356w, ../assets/logo-bredtmann-lg.png 506w, ../assets/logo-bredtmann-xl.png 712w"
            loading="lazy"
            alt="Logo Bredtmann - wundervolle Haare"
          /> -->
        </v-row>
        <v-row justify="center">
          <v-btn v-for="site in socialmedia" :key="site.icon" :href="site.link" class="mx-3" icon>
            <v-icon size="24px" color="secondary">{{ site.icon }}</v-icon>
          </v-btn>
        </v-row>
      </v-col>

      <v-col id="news"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Aktuelles
        </h2>

        <p justify="center" class="mx-3">
          <span>
            <br>
            Liebe Kunden,<br>
            <br>
            wir haben <strong>montags geschlossen</strong>.<br>
            <br>
            Ihr Friseur Bredtmann Team<br>
          </span>
        </p>
      </v-col>

      <v-col id="appointment"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Termin
        </h2>

        <p justify="center" class="mx-3">
          <span>
            Zur Terminvereinbarung erreichen Sie uns während der üblichen Öffnungszeiten telefonisch unter:<br>
            <a href="tel:023367015">02336 7015</a><br>
            <br>
            Eine Terminbuchung per E-Mail ist leider nicht möglich.<br>
          </span>
        </p>
      </v-col>

      <v-col id="openinghour"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Unsere Öffnungszeiten
        </h2>

        <v-row justify="center">
          <v-simple-table>
            <!-- <thead>
              <tr>
                <th class="text-left">Wochentag</th>
                <th class="text-left">Uhrzeiten</th>
              </tr>
            </thead> -->
            <tbody>
              <tr>
                <td>Montag</td>
                <!--<td align="right">10 - 18:30 Uhr</td>-->
                <td align="right"><strong>geschlossen</strong></td>
              </tr>
              <tr>
                <td>Dienstag - Freitag</td>
                <td align="right">9 - 18:30 Uhr</td>
              </tr>
              <tr>
                <td>Samstag</td>
                <td align="right">8 - 14:00 Uhr</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-row>
      </v-col>

      <v-col id="price"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Preise
        </h2>

        <v-row justify="center">
          <v-simple-table>
            <template v-for="(item,i) in prices">
            <thead :key=i>
              <tr>
                <th class="text-left secondary--text subtitle-1" style="font-weight:bold">{{ item.kategorie }}</th>
                <th class="text-center secondary--text subtitle-2">EUR</th>
              </tr>
            </thead>
            <tbody :key=i>
              <tr v-for="price in item.liste" :key="price.name">
                <td align="left">{{ price.name }}</td>
                <td>{{ price.preis }}<span v-if="price.lang_preis"><br><small>(lang {{ price.lang_preis }})</small></span></td>
              </tr>
            </tbody>
            </template>
          </v-simple-table>
        </v-row>
        <div class="mt-3"><small>Alle Preise inklusive 19% MwSt.</small></div>
      </v-col>

      <v-col id="product"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Produkte
        </h2>

        <v-row justify="center">
          <v-simple-table>
            <template v-for="(item,i) in products">
            <thead :key=i>
              <tr>
                <th class="text-left secondary--text subtitle-1" style="font-weight:bold">{{ item.kategorie }}</th>
                <th class="text-left secondary--text subtitle-2">Menge</th>
                <th class="text-center secondary--text subtitle-2">EUR</th>
              </tr>
            </thead>
            <tbody :key=i>
              <template v-for="price in item.liste">
              <tr v-if="price.name == ''" :key=price.name class="listentry--empty"><td></td><td></td><td></td></tr>
              <tr v-else :key=price.name>
                <td align="left">{{ price.name }}</td>
                <td align="left">{{ price.menge }}</td>
                <td>{{ price.preis }}</td>
              </tr>
              </template>
            </tbody>
            </template>
          </v-simple-table>
        </v-row>
        <div class="mt-3"><small>Alle Preise inklusive 19% MwSt.</small></div>
      </v-col>

      <v-col id="impressum"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Impressum
        </h2>

        <v-row justify="center" class="my-5">
          Onofria GmbH<br/>
          Hauptstr. 67<br/>
          58332 Schwelm
        </v-row>
        <v-row justify="center" class="my-5">
          Telefon: 02336 7015<br/>
          E-Mail: {{ mail }}
        </v-row>
        <v-row justify="center" class="my-5">
          Geschäftsführerin: Onofria Bredtmann<br/>
          Registernummer: HRB 7542 (Amtsgericht Hagen)<br/>
          U.St. ID-Nr. DE252135303
        </v-row>
        <v-row justify="center" class="my-5">
          <a color="secondary--text" href="/datenschutz.html">Datenschutzerklärung gemäß DS-GVO</a>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.listentry--empty td
{
  height: 15px;
}
</style>

<script>
  function decode(value) {
    return value.replace('*', '@').replace(/~/g, '.').split("").reverse().join("");
  }

  export default {
    name: 'HelloWorld',

    data: () => ({
      mail: decode('ed.nnamtderb-ruesirf*ofni'),
      socialmedia: 
        [
          {
            link: 'https://www.facebook.com/pg/bredtmann.schwelm',
            icon: 'mdi-facebook'
          },
          {
            link: 'https://www.instagram.com/bredtmann/',
            icon: 'mdi-instagram'
          }
        ],
      prices: [
        {
          kategorie: 'Damen',
          liste: [{
            name:  'Waschen, föhnen oder legen (je nach Haarlänge)',
            preis: 'ab 27,-',
            lang_preis: 'bis 30,-',
          },
          {
            name:  'Waschen, schneiden, selber föhnen (je nach Haarlänge)',
            preis: 'ab 40,-',
            lang_preis: 'bis 45,-',
          },
          {
            name:  'Waschen, schneiden, föhnen oder legen (je nach Haarlänge)',
            preis: 'ab 52,-',
            lang_preis: 'bis 57,-',
          }]
        },
        {
          kategorie: 'Färbungen & Tönen',
          liste: [{
            name:  'Tönen (je nach Menge)',
            preis: 'ab 35,-',
          },
          {
            name:  'Ansatzfärbung (je nach Farbmenge)',
            preis: 'ab 35,-',
          },
          {
            name:  'Ansatzfärbung (feine Haare, geringe Farbmenge bis 20g)',
            preis: 'ab 30,-',
          },
          {
            name:  'Abmattieren',
            preis: '15,-',
          },
          {
            name:  '­Hellerfärbung, Ansatz',
            preis: 'ab 35,-',
          },
          {
            name:  'Neufärbung, mit Haarlängen bis in die Spitzen (je nach Haarlänge)',
            preis: 'ab 50,-',
          },
          {
            name:  'Neufärbung, mit Vorblondierung bis in die Spitzen (je nach Haarlänge)',
            preis: 'ab 80,-',
          }]
        },
        {
          kategorie: 'Strähnen',
          liste: [{
            name:  'Foliensträhnen (je nach Haarlänge)',
            preis: 'ab 50,-',
          },
          {
            name:  'Haubensträhnen',
            preis: 'ab 45,-',
          },
          {
            name:  'Painting - Strähnchen wie gemalt (je nach Haarlänge)',
            preis: 'ab 50,-',
          },
          {
            name:  'Balayage (Termin nur mit 50 EUR Anzahlung)',
            preis: 'ab 150,-',
          }]
        },
        {
          kategorie: 'Herren',
          liste: [{
            name:  'Maschinenschnitt',
            preis: 'ab 10,-',
          },
          {
            name:  'Waschen, schneiden, föhnen',
            preis: 'ab 27,-',
          }]
        },
        {
          kategorie: 'Studentinnen und Schülerinnen',
          liste: [{
            name:  'Waschen, schneiden, selber föhnen',
            preis: 'ab 25,-',
          },
          {
            name:  'Waschen, schneiden, föhnen, komplett',
            preis: 'ab 35,-',
            lang_preis: 'bis 40,-',
          }]
        },
        {
          kategorie: 'Studenten und Schüler',
          liste: [{
            name:  'Waschen, schneiden, föhnen, komplett',
            preis: 'ab 23,-',
          }]
        },
        {
          kategorie: 'Kinderhaarschnitt',
          liste: [{
            name:  'Kinderhaarschnitte bis 5 Jahre',
            preis: 'ab 15,-',
          },
          {
            name:  'Kinderhaarschnitte bis 12 Jahre',
            preis: 'ab 20,-',
          }]
        },
        {
          kategorie: 'Kosmetik',
          liste: [{
            name:  'Wimpern färben',
            preis: 'ab 12,-',
          },
          {
            name:  'Augenbrauen färben',
            preis: 'ab 9,-',
          },
          {
            name:  'Augenbrauen zupfen',
            preis: 'ab 6,50',
          },
          {
            name:  'Paket (Wimpern und Augenbrauen färben + Augenbrauen zupfen)',
            preis: 'ab 25,-',
          },
          {
            name:  'Haarentfernung mit Faden-Technik (ganzes Gesicht)',
            preis: '15,-',
          }]
        },
        {
          kategorie: 'Pflege',
          liste: [{
            name:  'Pflege, Packung, Maske',
            preis: 'ab 8,-',
          },
          {
            name:  'Mangala (Tönungskur/-pflege)',
            preis: 'ab 15,-',
          },
          {
            name:  'Trijuven (Therapie zur Haarverjüngung)',
            preis: 'ab 15,-',
          }]
        },
        {
          kategorie: 'Dauerwellen',
          liste: [{
            name:  'Dauerwellen-Paket (Schneiden, Frisur-Festiger und Haarspray, komplett)',
            preis: 'ab 92,-',
          },
          {
            name:  'Dauerwelle ohne Schneiden',
            preis: 'ab 45,-',
          }]
        },
        {
          kategorie: 'Hochsteckfrisuren',
          liste: [{
            name:  'Brautfrisur (Termin nur mit 50 EUR Anzahlung)',
            preis: 'ab 100,-',
          },
          {
            name:  'Abi-, Abschlussball (Termin nur mit 20 EUR Anzahlung)',
            preis: 'ab 45,-',
          },
          {
            name:  'Flechten',
            preis: 'ab 15,-',
          }]
        },
      ],
      products: [
        {
          kategorie: 'GLYNT 01 HYDRO',
          liste: [{
            name:  'HYDRO Vitamin Shampoo',
            menge: '250ml',
            preis: '12,60',
          },
          {
            name:  'HYDRO Vitamin Lotion',
            menge: '200ml',
            preis: '14,40',
          },
          {
            name:  'HYDRO Vitamin Rinse',
            menge: '200ml',
            preis: '13,00',
          }]
        },
        {
          kategorie: 'GLYNT 02 VOLUME',
          liste: [{
            name:  'VOLUME Energy Shampoo',
            menge: '250ml',
            preis: '12,60',
          },
          {
            name:  'VOLUME Energy Spray',
            menge: '100ml',
            preis: '20,90',
          },
          {
            name:  '­VOLUME Energy Mask',
            menge: '200ml',
            preis: '14,40',
          }]
        },
        {
          kategorie: 'GLYNT 03 REVITAL',
          liste: [{
            name:  'REVITAL Regain Shampoo',
            menge: '250ml',
            preis: '12,60',
          },
          {
            name:  'REVITAL Regain Milk',
            menge: '200ml',
            preis: '14,40',
          },
          {
            name:  'REVITAL Regain Mask',
            menge: '200ml',
            preis: '14,40',
          }]
        },
        {
          kategorie: 'GLYNT 04 DERMA',
          liste: [{
            name:  'DERMA Regulate Shampoo',
            menge: '250ml',
            preis: '13,30',
          },
          {
            name:  'DERMA E.F.A. Stimulant',
            menge: '100ml',
            preis: '12,20',
          },
          {
            name:  'DERMA Regulate Tonic',
            menge: '100ml',
            preis: '12,15',
          }]
        },
        {
          kategorie: 'GLYNT 05 NUTRI',
          liste: [{
            name:  'NUTRI Oil Shampoo',
            menge: '250ml',
            preis: '13,30',
          },
          {
            name:  'NUTRI Oil Mask',
            menge: '100ml',
            preis: '26,50',
          },
          {
            name:  'NUTRI Oil Elixir',
            menge: '200ml',
            preis: '14,40',
          }]
        },
        {
          kategorie: 'GLYNT Pflege TRIJUVEN&copy;',
          liste: [{
            name:  'TRIJUVEN&copy; Step 3',
            menge: '200ml',
            preis: '23,00',
          }]
        },
        {
          kategorie: 'GLYNT Styling SMOOTH',
          liste: [{
            name:  'MALIBU Smoothing Cream',
            menge: '100ml',
            preis: '14,20',
          },
          {
            name:  'BREEZE Detangler Spray',
            menge: '200ml',
            preis: '16,90',
          }]
        },
        {
          kategorie: 'GLYNT Styling GLOSS',
          liste: [
          {
            name:  'GLOSS Polish',
            menge: '75ml',
            preis: '13,00',
          },
          {
            name:  'PEARL Design Gloss',
            menge: '100ml',
            preis: '10,90',
          },
          {
            name:  'JELLY Extreme Styler',
            menge: '100ml',
            preis: '12,20',
          },
          {
            name:  'DIAMOND Shine Spray',
            menge: '100ml',
            preis: '14,20',
          }
          ]
        },
        {
          kategorie: 'GLYNT Styling TEXTURE',
          liste: [
          {
            name:  'BLIZZARD Ice Spray',
            menge: '200ml',
            preis: '14,20',
          },
          {
            name:  'CARIBBEAN Spray Wax',
            menge: '150ml',
            preis: '14,20',
          },
          {
            name:  'BORA Paste',
            menge: '75ml',
            preis: '14,20',
          },
          {
            name:  'MAT Modeler',
            menge: '75ml',
            preis: '14,20',
          },
          {
            name:  'SPIDER Cream',
            menge: '75ml',
            preis: '14,20',
          },
          {
            name:  'KANGOO Shaper',
            menge: '75ml',
            preis: '14,20',
          },
          {
            name:  'ROK Spray Foam',
            menge: '200ml',
            preis: '14,20',
          }
          ]
        },
        {
          kategorie: 'GLYNT Styling SETTING',
          liste: [
          {
            name:  'VELVET Mousse Strong',
            menge: '200ml',
            preis: '14,20',
          },
          {
            name:  'ELASTIC Curl Spray',
            menge: '200ml',
            preis: '14,20',
          }
          ]
        },
        {
          kategorie: 'GLYNT Styling SPRAYS',
          liste: [
          {
            name:  'MISTRAL Build up Spray',
            menge: '300ml',
            preis: '15,30',
          }
          ]
        }
      ],
    }),
    

  methods: {
    getImage() {
      console.log(this.$vuetify.breakpoint)
      return require('../assets/logo-bredtmann-' + this.$vuetify.breakpoint.name + '.png');
    }
  }
  }
</script>
